<template>
  <!-- TOP CARD -->
  <section class="px-4 py-4 mb-3 text-white dark-with-overlay rounded-xl">
    <div class="flex">
      <div>
        <div
          @click="showAmount = !showAmount"
          class="px-4 py-1 text-xs uppercase border border-gray-100 rounded-full w-fit gap-x-2 flex-items-center cursor-pointer"
        >
          <img
            v-if="showAmount"
            src="@/assets/svg/eye-slash.svg"
            alt=""
            class="size-5"
          />
          <img v-else src="@/assets/svg/eye.svg" alt="" class="size-5" />
          <p>{{ text }}</p>
        </div>

        <!-- <p class="mt-4 text-[1.75rem] font-millik">
          {{ currencyFormat(totalAmount) }}
        </p> -->

        <div>
          <p class="mt-4 text-[1.75rem] font-millik">
            <span v-if="showAmount" class="font-millik">
              {{ currencyFormat(totalAmount) }}
            </span>
            <span class="font-millik" v-else>{{ currencySymbol2 }} *****</span>
          </p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { currencyFormat, translateText } from "@/core/helpers/utility";

export default {
  props: {
    totalAmount: {
      type: Number,
      default: 0,
    },
    text: {
      type: String,
      default: translateText(`supply.totalAmt`),
    },
  },

  data() {
    return {
      translateText,
      currencyFormat,
      showAmount: false,
      userInfo: JSON.parse(localStorage.getItem("entityDetails")),
    };
  },

  computed: {
    currencySymbol2() {
      return this.userInfo?.currency === "NGN" ? "NGN" : "USD";
    },
  },
};
</script>
